import { render } from "./VTab.vue?vue&type=template&id=b36eea52&ts=true"
import script from "./VTab.vue?vue&type=script&lang=ts"
export * from "./VTab.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__